export const conversation1 = {
  company_id: 4,
  contact_id: null,
  created_at: '2019-04-23T21:29:42',
  id: 1,
  property_display: 'Some property name',
  last_message: {
    conversation_id: 1,
    created_at: '2019-04-24T00:31:45',
    id: 5,
    message: 'Test message',
    photos: [],
    sender: true,
    type_message: 'pre_arrival',
    user: null,
  },
  phone_number: {
    dial_code: '1',
    phone_number: '6072276354',
  },
  reservation_guest_id: null,
  type_conversation_status: {
    code: 'inbox',
    name: 'Inbox',
  },
  unread_message_count: 0,
  important: false,
};

export const conversation2 = {
  company_id: 4,
  contact_id: 1,
  created_at: '2019-04-23T21:29:42',
  id: 1,
  last_message: {
    conversation_id: 1,
    created_at: '2019-04-24T00:31:45',
    id: 5,
    message: 'Test message',
    photos: [],
    sender: true,
    type_message: null,
    user: null,
  },
  phone_number: {
    dial_code: '1',
    phone_number: '6072276354',
    country_code: 'us',
  },
  reservation_guest_id: null,
  type_conversation_status: {
    code: 'inbox',
    name: 'Inbox',
  },
  unread_message_count: 0,
  important: true,
};

export const conversations = [conversation1, conversation2];
